module.exports = __webpack_public_path__ + "static/media/hiv-aids.d40fbdd8.jpeg";